import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_FETCH_ACCOUNT_DATA_BEGIN,
  MANAGE_SUBS_FETCH_ACCOUNT_DATA_SUCCESS,
  MANAGE_SUBS_FETCH_ACCOUNT_DATA_FAILURE,
  MANAGE_SUBS_FETCH_ACCOUNT_DATA_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';

export function fetchAccountData(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_FETCH_ACCOUNT_DATA_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      let conditions = args;
      if(args.sortedBy === undefined || args.sortedBy === null) {
        conditions = {
          ...conditions,
          sort: "descend",
          sortedBy: "modifiedTimestamp",
        }
      }
      const doRequest = axios.post(`${API_REQUEST_URL}/getManageAccountsData`, conditions, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: MANAGE_SUBS_FETCH_ACCOUNT_DATA_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_FETCH_ACCOUNT_DATA_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchAccountDataError() {
  return {
    type: MANAGE_SUBS_FETCH_ACCOUNT_DATA_DISMISS_ERROR,
  };
}

export function useFetchAccountData() {
  const dispatch = useDispatch();

  const { accountData, fetchAccountDataPending, fetchAccountDataError } = useSelector(
    state => ({
      accountData: state.manageSubs.accountData,
      fetchAccountDataPending: state.manageSubs.fetchAccountDataPending,
      fetchAccountDataError: state.manageSubs.fetchAccountDataError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(fetchAccountData(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchAccountDataError());
  }, [dispatch]);

  return {
    accountData,
    fetchAccountData: boundAction,
    fetchAccountDataPending,
    fetchAccountDataError,
    dismissFetchAccountDataError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_FETCH_ACCOUNT_DATA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchAccountDataPending: true,
        fetchAccountDataError: null,
      };

    case MANAGE_SUBS_FETCH_ACCOUNT_DATA_SUCCESS:
      // The request is success
      return {
        ...state,
        accountData: action.data,
        fetchAccountDataPending: false,
        fetchAccountDataError: null,
      };

    case MANAGE_SUBS_FETCH_ACCOUNT_DATA_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchAccountDataPending: false,
        fetchAccountDataError: action.data.error,
      };

    case MANAGE_SUBS_FETCH_ACCOUNT_DATA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchAccountDataError: null,
      };

    default:
      return state;
  }
}
